import React from "react";

import { CloudCertModalOverlay } from "./cloud-cert-modal.styles";
import CloudCertDropDown from "../cloud-cert-dropdown/cloud-cert-dropdown.component";

const CloudCertModal =
  (WrappedComponent) =>
  ({ cloudCertModal, ...otherProps }) => {
    const { user } = otherProps;
    return cloudCertModal.open && user ? (
      <CloudCertModalOverlay>
        <CloudCertDropDown {...otherProps} />
      </CloudCertModalOverlay>
    ) : (
      <WrappedComponent {...otherProps} />
    );
  };

export default CloudCertModal;
